import { createAuthenticatedAxiosInstance } from "../auth/auth.slice";

const baseUrl = import.meta.env.VITE_API_URL;

export const purchaseService = {
    getAllPurchases: async (params) => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.get(baseUrl + "purchases", { params });
        return response.data;
    },

    createPurchase: async (purchaseData) => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.post(baseUrl + "purchases", purchaseData);
        return response.data;
    },

    getPurchaseDetails: async (id) => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.get(`${baseUrl}purchases/${id}`);
        return response.data;
    },

    addPayment: async (id, paymentData) => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.post(`${baseUrl}purchases/${id}/payments`, paymentData);
        return response.data;
    },

    getCreditPurchases: async () => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.get(`${baseUrl}purchases/credit`);
        return response.data;
    },
};
